'use client';

import SvgClear from '@hc-frontend/core-icons/kit/clear';
import { CallStatus as CallStatusType } from '@hc-frontend/core-types';
import { useSSE } from '@hc-frontend/core-ui';
import { useEffect, useState } from 'react';

import DurationBadge from '../../atoms/call-status-duration-badge/duration-badge';
import CallReconnect from '../../atoms/call-status-reconnect/call-reconnect';
import CallReview from '../../atoms/call-status-review/call-review';
import StatusBadge from '../../atoms/call-status-status-badge/status-badge';

export function CallStatus() {
  const { messages } = useSSE();
  const [callStatus, setCallStatus] = useState<CallStatusType>(
    CallStatusType.Enum.IDLE,
  );
  const [formattedPhoneNumber /*setFormattedPhoneNumber*/] =
    useState('4444-444444');

  // TODO: Retrieve actual call start timestamp, maybe from the SSE messages
  const [callStartTimestamp, setCallStartTimestamp] = useState<number>(
    Math.floor(new Date().getTime() / 1000),
  );

  useEffect(() => {
    if (messages && messages.length === 1) {
      // TODO: Define the message that will trigger the component, and will set the phone number
      setCallStatus(CallStatusType.Enum.ON_CALL);
      // setFormattedPhoneNumber()
    }

    if (messages && messages.length === 2) {
      setCallStatus(CallStatusType.Enum.ENDED_TOO_QUICKLY);
    }
  }, [messages]);

  const reconnect = () => {
    setCallStatus(CallStatusType.Enum.ON_CALL);
    setCallStartTimestamp(Math.floor(new Date().getTime() / 1000));
    // TODO: Trigger reconnection logic
    console.log('Should reconnect');
  };
  const connectToSomeoneElse = () => {
    setCallStatus(CallStatusType.Enum.ON_CALL);
    setCallStartTimestamp(Math.floor(new Date().getTime() / 1000));
    // TODO: Trigger reconnection logic
    console.log('Should connectToSomeoneElse');
  };

  if (callStatus === CallStatusType.Enum.IDLE) {
    return null;
  }

  return (
    <div
      className={`
        z-10
        border-[1px] border-[rgba(0, 0, 0, 0.2)]
        bg-[#FFF]
        px-[22px] py-[18px]
        w-[630px] max-w-[90%]
        fixed rounded-lg right-[20px] top-[20px]
        overflow-hidden
      `}
      data-testid="call-status"
    >
      <div
        className={`w-[300px] rounded-full`}
        style={{
          boxShadow: `rgb(245, 165, 0) 150px ${callStatus === CallStatusType.Enum.ON_CALL ? '330px' : '430px'} 1000px 25px`,
        }}
      ></div>
      <div>
        <SvgClear
          data-testid="close-call-status"
          onClick={() => setCallStatus(CallStatusType.Enum.IDLE)}
          className={`ml-auto w-[18px] h-[18px] cursor-pointer`}
          color={'rgba(0, 0, 0, 0.2)'}
        />
      </div>
      <div className={`flex justify-between mt-4-4`}>
        <StatusBadge callStatus={callStatus} />
        <DurationBadge
          callStartTimestamp={callStartTimestamp}
          isActive={callStatus === CallStatusType.Enum.ON_CALL}
        />
      </div>
      <div
        className={`mt-8-8 border-[1px] py-16-16 px-8-8 text-center rounded`}
      >
        HealthCare Agent logo
      </div>
      {callStatus === CallStatusType.Enum.ENDED && (
        <div className={`mt-4-4`}>
          <CallReview
            connectToSomeoneElse={connectToSomeoneElse}
            formattedPhoneNumber={formattedPhoneNumber}
          />
        </div>
      )}
      {callStatus === CallStatusType.Enum.ENDED_TOO_QUICKLY && (
        <div className={`mt-4-4`}>
          <CallReconnect
            reconnect={reconnect}
            connectToSomeoneElse={connectToSomeoneElse}
            formattedPhoneNumber={formattedPhoneNumber}
          />
        </div>
      )}
    </div>
  );
}
